import { useState } from "react";
import { AdminTemplate, ProductGroupsList } from "../../components";
import { ProductGroupModal } from '../../components/molecules';
import { getProductGroups, useGetProductGroups, ProductGroup, useUpdateProductGroup } from "../../hooks";
import { useConfirmationModal } from "../../hooks/useConfirmationModal";
import { useQueryClient } from "react-query";
import { downloadExcel } from "../../util/downloadExcel";

export const ProductGroupsPage = () => {
  const [isProductGroupModalOpen, setIsProductGroupModalOpen] = useState(false);
  const queryClient = useQueryClient();
  const [refetchTrigger, setRefetchTrigger] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const {
    data: productGroups,
    isLoading,
  } = useGetProductGroups({
    status: activeTabIndex === 0 ? "ACTIVE" : "PASSIVE",
  });
  const updateProductGroup = useUpdateProductGroup();

  const handleActivate = (productGroup: ProductGroup) => {
    updateProductGroup.mutate(
      { ...productGroup, status: activeTabIndex === 0 ? "ACTIVE" : "PASSIVE" },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["product", "groups"]);
        },
      }
    );
  };

  const handleAddProductGroup = () => {
    setIsProductGroupModalOpen(true);
  };

  const handleCloseProductGroupModal = () => {
    setIsProductGroupModalOpen(false);
  };

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Ürün Grupları Listeleme",
        onClickAddButton: handleAddProductGroup
      }}
    >
      <ProductGroupsList refetchTrigger={refetchTrigger} />
      <ProductGroupModal
        mode='add'
        key={'add-product-group'}
        open={isProductGroupModalOpen}
        onClose={handleCloseProductGroupModal}
        onSuccess={() => {
          queryClient.invalidateQueries(["product", "groups"]);
        }}
      />
    </AdminTemplate>
  );
};